import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';

const apiBase = '/api/claim_groups';

const claimProjectReportService = {
  update(claimGroupId, report) {
    return fetch(`${apiBase}/${claimGroupId}/claim_project_reports/${report.id}`, {
      ...request.put,
      body: JSON.stringify({ claim_project_report: report })
    });
  },

  delete(claimGroupId, reportId) {
    return fetch(`${apiBase}/${claimGroupId}/claim_project_reports/${reportId}`, request.delete);
  },

  all(params) {
    return fetch(`/api/claim_project_reports?${params}`, request.get);
  },

  get(claimGroupId, reportId) {
    return fetch(`${apiBase}/${claimGroupId}/claim_project_reports/${reportId}`, request.get);
  },

  create(claimGroupId, report) {
    return fetch(`${apiBase}/${claimGroupId}/claim_project_reports/`, {
      ...request.post,
      body: JSON.stringify({ claim_project_report: report })
    });
  },

  useDelete({ setLoading, handleToaster, onSuccess }) {
    const { t } = useTranslation();

    return serviceMethods.useDelete({
      setLoading,
      onSuccess,
      callback: useCallback(async ({ claimGroupId, reportId }) => {
        await claimProjectReportService.delete(claimGroupId, reportId);

        handleToaster('success', t('project_deleted_successfully'));
      }, [t, handleToaster]),
      modalConfirm: {
        type: 'delete',
        confirmationButtonText: ({ confirmationButtonText }) => confirmationButtonText,
      }
    });
  }
};

export default claimProjectReportService;
